import * as React from "react";
import { DatabaseDetailDataPropsT } from "../types";
import MainContainer from "./partials/MainContainer";

export default ({ data }: DatabaseDetailDataPropsT): JSX.Element => {
  const { influencerId, session } = data;

  return <MainContainer influencerId={influencerId} session={session} />;
};
